import { cn } from '@newcore/ui/cn';
import newcoreAppTextLogo from '@/assets/newcore-app-text-logo.svg';

export const LogoVertical = ({ className }: { className?: string }) => (
  <img
    className={cn('h-16', className)}
    src={newcoreAppTextLogo}
    alt='NewCore Logo'
  />
);
